export const FIVE_MINUTES_MS = 5 * 60 * 1000
